// extracted by mini-css-extract-plugin
module.exports = {"main_container":"Templates_main_container__2Sbun","seg_placeholder":"Templates_seg_placeholder__uTldq"};